import React from 'react'
import '../../App.css'
import './Contest.css'
import web2 from '../images/img-2.jpg'
import { FaCoffee } from 'react-icons/fa'
import { MdOutlineEmojiEvents} from 'react-icons/md'
export const ContestDetail = () => {
  return (
    <>
      <section className="contestDetail">
        <div className="custom-shape-divider-bottom-1648805572">
          <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
            <path d="M985.66,92.83C906.67,72,823.78,31,743.84,14.19c-82.26-17.34-168.06-16.33-250.45.39-57.84,11.73-114,31.07-172,41.86A600.21,600.21,0,0,1,0,27.35V120H1200V95.8C1132.19,118.92,1055.71,111.31,985.66,92.83Z" className="shape-fill"></path>
          </svg>
        </div>

        <div className="container">
          <div className="row">
            <div className="col-md-8 col-sm-12">
              <div className="contest-text">
                <MdOutlineEmojiEvents color="white" size="5em" />
                <h1>Startup Contest</h1>
                <p className='pe-5'>Entrepreneurial challenges to promote and encourage entrepreneurs, startup founders build their entrepreneurial skills, leverage their skills as well learn from them through hands-on workshops, and win exciting prizes.</p>
              </div>
            </div>
            <div className="col-md-4 col-sm-12">
              <div className="contest-img2">
                <img src={web2} alt="erb" className='img-fluid' />

              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="container w-75 m-auto">
        <div className="ques">
          <h1><span>Can you believe that the startup contest is finally here? </span></h1>
          <p> If you’re currently stuck inside due to current world circumstances, we’d like to encourage you to dig through your creative archives and share your startup failure to success story and unbox your opportunities.

            Say goodbye to fear and be thankful for more beautiful days ahead. We want to encourage young entrepreneurs to take risks and create opportunities.   </p>
        </div>
        <div className="ques mt-5">
          <h1><span>How do you come up with ideas for launching a startup?  </span></h1>
          <p> Share your startup story along with the challenges you have encountered during those periods and create your own opportunities of networking with potential investors.    </p>
        </div>

        <div className="ques mt-5">
          <span className='subtitle'>Our Focus on endorsing young entrepreneurs:  </span>
          <ul>
            <li><a href="">Win Cash Prize Up To Nrs. 1,00,000

            </a></li>
            <li><a href="">Win Microbusiness Revolution Workshop Sessions </a></li>

          </ul>
        </div>
        <div className="ques mt-5">
          <span className='subtitle'>MISSION AIRLIFT OPPORTUNITIES:    </span>
      <p>An inspiring and encouraging startup story will get an opportunity to be associated as one of our business partners on our new project <b>“LACUNA PLANT”</b> .  </p>
        </div>

      </div>
    </>
  )
}
